'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner, toast, type ToasterProps } from 'sonner'
import {
  CircleCheckIcon,
  InfoIcon,
  TriangleAlertIcon,
  OctagonXIcon,
  Loader2Icon,
} from 'lucide-react'

const Toaster = ({ ...props }: ToasterProps) => {
  // resolvedTheme, not theme: with theme="system" sonner resolves dark/light
  // from the OS itself, which can disagree with the `.dark` class next-themes
  // puts on the document — and our tokens follow the class.
  const { resolvedTheme = 'light' } = useTheme()

  return (
    <Sonner
      theme={resolvedTheme as ToasterProps['theme']}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          // Inline: sonner injects an unlayered font-family rule at runtime
          // that a stylesheet of ours would lose to.
          '--font-sans': 'var(--font-geist, sans-serif)',
          fontFamily: 'var(--font-sans)',
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: 'cn-toast',
          // Sonner hard-codes the description colour in an unlayered stylesheet
          // it appends at runtime; only `!important` takes it back to a token.
          description: 'text-muted-foreground!',
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
